import { MigrationInterface, QueryRunner, TableColumn, TableIndex } from 'typeorm'

/**
 * Board.sourceImportSessionId — zero-to-twin import 로 생성된 보드의 source 추적.
 * board-import 의 ImportSession.id 와 약결합 (string FK 없이).
 * synchronize:true 환경에서는 entity 변경만으로 자동 적용되지만, 명시적 migration 으로
 * synchronize:false 운영 환경도 커버.
 */
export class AddSourceImportSessionToBoard1762190000000 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<void> {
    const table = await queryRunner.getTable('board')
    if (!table) return

    if (!table.findColumnByName('source_import_session_id')) {
      await queryRunner.addColumn(
        'board',
        new TableColumn({
          name: 'source_import_session_id',
          type: 'varchar',
          isNullable: true
        })
      )
    }

    const refreshed = await queryRunner.getTable('board')
    if (refreshed && !refreshed.indices.find(i => i.name === 'ix_board_4')) {
      await queryRunner.createIndex(
        'board',
        new TableIndex({
          name: 'ix_board_4',
          columnNames: ['source_import_session_id'],
          isUnique: false
        })
      )
    }
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    const table = await queryRunner.getTable('board')
    if (!table) return

    if (table.indices.find(i => i.name === 'ix_board_4')) {
      await queryRunner.dropIndex('board', 'ix_board_4')
    }
    if (table.findColumnByName('source_import_session_id')) {
      await queryRunner.dropColumn('board', 'source_import_session_id')
    }
  }
}
